// extracted by mini-css-extract-plugin
module.exports = {"deleteForm":"DeleteForm_deleteForm__15gfn","deleteLink":"DeleteForm_deleteLink__28vFZ"};